<template>
  <v-container>
    <div style="height: 50%; width: 50%;">
      <v-img
      id="tupp"
      :src = "require('@/assets/tupptupp.png')">
      </v-img>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => {
    return {
      // variabler
      fps: 60,
      posx: 0, // postion
      posy: 0,
      langd_skarm: window.innerHeight * 0.15, // skärmstrlek
      bredd_skarm: window.innerWidth * 0.4,
      t: -300, // räknaren går från -300<t<300
      storleksskalning: 1, // skalning av bild
      updatePos: 0,
      DodaTuppNastaIteration: false,
      rotation: 0,
      omega: 5 // rotationshastighet
    }
  },
  computed: {
    storlek: function () {
      return 'width:' + this.storlek_var + 'vw; "{ top: 10vh, left: 10vw }"'
    },
    location: function () {
      return 'width: 10vw; height: 10eh; left:' + this.posx + 'vw; border: 1px solid #000; position: absolute;'
    }
  },
  methods: {
    SendTupp () {
      this.updatePos = setInterval(this.moveObject, 10)
    },
    moveObject () {
      // Updatera postionen, funktionen innan bredd/längd ska gå finna i intervall [-1,1/2] d.v.s den räknar i andel av skärmstorlek
      this.posx = -1 / 90000 * (this.t ** 2 - 150 * this.t - 45000) * this.bredd_skarm
      this.posy = (0.2 + 1 / (173.21 ** 2) * (this.t ** 2 - 173.21 ** 2)) * this.langd_skarm
      this.storleksskalning = (0.05 + 0.9 / (300 ** 2) * (this.t) ** 2) // skalar figuren
      this.t += 1.5
      this.rotation += this.omega

      // starta om tiden
      /* if (this.t >= 300) {
        this.t = -300
      } */
      if (this.posy >= 1 * this.langd_skarm && this.t > 0) {
        this.DodaTuppNastaIteration = true
      }
      if (this.DodaTuppNastaIteration) {
        this.storleksskalning = 0
        clearInterval(this.updatePos)
      }
      // faktisk updatering av postionen för tuppen
      document.getElementById('tupp').style.transform = `translate(${this.posx}px, ${this.posy}px) scale(${this.storleksskalning * 0.9 * 1.1},${this.storleksskalning * 0.45 * 1.1}) rotate(${this.rotation}deg)`
      // document.getElementById('tupp').style.transform = `rotate(${1}deg)`
    }
  },
  mounted () {
    this.SendTupp()
  }
}
</script>
